import { Spinner } from '@openedx/paragon';
import { PageLoaderProps } from './types';

export const PageLoader = ({ loaderText }: PageLoaderProps) => (
  <div className="container-fluid py-5">
    <div className="d-flex justify-content-center align-items-center flex-column position-fixed page-loader">
      <Spinner
        animation="border"
        className="mie-3"
        screenReaderText={loaderText}
      />
    </div>
  </div>
);
